export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/efcca1ae64e2adea8f6cbcf3fc677bc7/4219d507165acd7aebcdebb0341a37df.png" 
                alt="Handyman of Stillwater" 
                className="h-12 w-auto"
              />
              <span className="text-xl font-bold">Handyman of Stillwater</span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Your trusted partner for professional home repair and improvement services across Stillwater and Northern Oklahoma. Quality workmanship, reliable service, fair pricing.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-lg transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-lg transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-lg transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-teal-400 transition-colors text-left">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('areas')} className="text-gray-400 hover:text-teal-400 transition-colors text-left">
                  Areas Served
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-teal-400 transition-colors text-left">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('lead-form')} className="text-gray-400 hover:text-teal-400 transition-colors text-left">
                  Get a Quote
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-xl text-teal-400 mt-1"></i>
                <div>
                  <a href="tel:4057476904" className="text-gray-400 hover:text-teal-400 transition-colors">
                    405-747-6904
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-xl text-teal-400 mt-1"></i>
                <div>
                  <a href="mailto:info@handymanofstillwater.com" className="text-gray-400 hover:text-teal-400 transition-colors break-all">
                    info@handymanofstillwater.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-xl text-teal-400 mt-1"></i>
                <div className="text-gray-400">
                  Serving Stillwater & Northern Oklahoma
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2024 Handyman of Stillwater. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}